<template>
  <div class="app container-md">
    <div class="NavHeader" >
      <NavHeader />
    </div>
    <div class="app_container">
      <router-view></router-view>
      <right-menu></right-menu>
      <NavFooter />
<!--      <left-menu></left-menu>-->
    </div>
  </div>
</template>

<script>
import NavHeader from "@@/components/NavHeader.vue";
import NavFooter from "@@/components/NavFooter.vue";
import rightMenu from "@@/components/rightMenu.vue";
import leftMenu from "@@/components/leftMenu.vue";

export default {
  components: {
    NavHeader,
    NavFooter,
    rightMenu,
    leftMenu,
  },
  created(){
  },
  watch:{
    '$route':{
        immediate:true,
        handler(n){
            if(n.path=='/'){
                this.$router.push('/home')
            }
            sessionStorage.setItem('menu',n.path)
        }
    }
  }
};
</script>
<style scoped>
.app{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  min-width: 1360px;
}
.NavHeader{
  height: 150px;
}
.app_container{
  height: calc(100% - 150px);
  //min-height: 748px;
  overflow: hidden;
  overflow-y: auto;
}

</style>
